import { Smartphone, Apple, Download } from "lucide-react";
import { RESTAURANT } from "@/data/menu";
import Reveal from "@/components/site/Reveal";

const APP_IMG = "/images/about-app.png";

export const APP_SECTION_TESTIDS = {
  section: "app-section",
  appStoreBtn: "app-section-appstore-btn",
  playStoreBtn: "app-section-playstore-btn",
};

const features = [
  "Full menu with photos & prices",
  "Delivery to Aundh & nearby areas",
  "Quick takeaway pre-order",
  "Real-time order tracking",
];

export default function MobileAppSection() {
  return (
    <section
      id="app"
      data-testid={APP_SECTION_TESTIDS.section}
      className="container-x scroll-mt-24 pb-24"
    >
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-white border border-borderc/60 shadow-sm">
          <div
            className="absolute -right-32 -top-32 w-96 h-96 rounded-full bg-brand/8 blur-3xl"
            aria-hidden="true"
          />
          <div
            className="absolute -left-24 -bottom-24 w-80 h-80 rounded-full bg-accent2/10 blur-3xl"
            aria-hidden="true"
          />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center p-8 sm:p-12 lg:p-16">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand/10 text-brand text-[0.7rem] uppercase tracking-[0.2em]">
                <Smartphone className="w-3.5 h-3.5" />
                Now on iOS &amp; Android
              </span>
              <h2 className="mt-5 font-serif text-4xl sm:text-5xl text-ink leading-[1.08] text-balance">
                The Giridhar app —
                <br />
                <span className="italic">order in a few taps.</span>
              </h2>
              <p className="mt-5 text-ink-muted text-base sm:text-lg leading-relaxed max-w-xl">
                Browse our full menu, place a delivery or takeaway order, track
                it in real-time, and skip the wait at pickup. Built in-house,
                with the same care we put into the food.
              </p>

              <ul className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-lg">
                {features.map((f) => (
                  <li
                    key={f}
                    className="flex items-start gap-2.5 text-sm text-ink"
                  >
                    <span className="mt-1 w-1.5 h-1.5 rounded-full bg-brand shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>

              <div className="mt-9 flex flex-wrap gap-3">
                <a
                  href="https://apps.apple.com/in/app/giridhar-veg-restaurant/id6802806066"
                  data-testid={APP_SECTION_TESTIDS.appStoreBtn}
                  className="inline-flex items-center gap-3 rounded-full bg-ink text-cream hover:bg-ink/90 px-6 py-3 text-sm font-medium tracking-wide transition-colors"
                  aria-label="Download on the App Store"
                >
                  <Apple className="w-5 h-5" />
                  <span className="flex flex-col items-start leading-tight">
                    <span className="text-[0.6rem] uppercase tracking-[0.18em] text-cream/65">
                      Download on the
                    </span>
                    <span className="text-sm">App Store</span>
                  </span>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.giridharveg.customerapp"
                  data-testid={APP_SECTION_TESTIDS.playStoreBtn}
                  className="inline-flex items-center gap-3 rounded-full bg-ink text-cream hover:bg-ink/90 px-6 py-3 text-sm font-medium tracking-wide transition-colors"
                  aria-label="Get it on Google Play"
                >
                  <Download className="w-5 h-5" />
                  <span className="flex flex-col items-start leading-tight">
                    <span className="text-[0.6rem] uppercase tracking-[0.18em] text-cream/65">
                      Get it on
                    </span>
                    <span className="text-sm">Google Play</span>
                  </span>
                </a>
              </div>
              <p className="mt-4 text-xs text-ink-muted">
                Prefer to call? Reach us anytime at{" "}
                <a
                  href={`tel:${RESTAURANT.phoneRaw}`}
                  className="text-brand font-medium hover:text-brand-hover"
                >
                  {RESTAURANT.phone}
                </a>
                .
              </p>
            </div>

            <div className="lg:col-span-5">
              <div className="relative mx-auto max-w-xs sm:max-w-sm">
                <div
                  className="absolute -inset-4 bg-brand/8 rounded-[2.5rem] rotate-3"
                  aria-hidden="true"
                />
                <img
                  src={APP_IMG}
                  alt="Giridhar Veg mobile app preview"
                  className="relative w-full rounded-[2rem] shadow-xl"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
